import { useWindowSize } from "usehooks-ts";

const tableBoxHeaderHeight = 48;
const tableHeaderHeight = 56;
const tableFooterHeight = 40;
const rowHeight = 40;

/**
 * Calculates the minimum height of a table box based on the number of rows
 * and the height of the page body.
 *
 * @param numRows The number of rows in the table.
 * @param numTablesOnPage The number of tables on the page.
 * @param subtractedPageHeight The height of any extra header content outside the table, to subtract from page height.
 * @param extraTableHeight Any extra height to add to the table.
 */
export const useTableBoxMinHeight = (
  numRows: number,
  numTablesOnPage: number,
  subtractedPageHeight = 0,
  extraTableHeight = 0,
) => {
  const { height: windowHeight } = useWindowSize();

  // window height minus header height
  const pageHeight = windowHeight - 64;

  const maxRows =
    Math.max(
      // Always leave room for at least one row
      1,
      Math.floor(
        Math.max(
          0,
          (pageHeight / numTablesOnPage -
            tableBoxHeaderHeight -
            tableHeaderHeight -
            subtractedPageHeight -
            tableFooterHeight) /
            rowHeight,
        ),
      ),
    ) + 0.5; // show half a row to indicate there are more rows

  return `${
    Math.min(numRows, Math.min(numRows, maxRows)) * rowHeight +
    tableBoxHeaderHeight +
    tableHeaderHeight +
    tableFooterHeight +
    extraTableHeight
  }px`;
};
